import * as tslib_1 from "tslib";
import { BaseEntity } from '../../_helpers';
import { Expose } from 'class-transformer';
var Category = /** @class */ (function (_super) {
    tslib_1.__extends(Category, _super);
    function Category() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    tslib_1.__decorate([
        Expose(),
        tslib_1.__metadata("design:type", String)
    ], Category.prototype, "name", void 0);
    return Category;
}(BaseEntity));
export { Category };
